<template>
  <div>
    <div
      class="flex cursor-pointer flex-col gap-sm rounded-md border border-neutral-200 bg-avtalat-gray p-sm"
      @click="() => (expanded = !expanded)"
    >
      <div class="flex flex-row justify-between">
        <span>{{ props.title }}</span>
        <div class="-m-xs p-xs">
          <FontAwesomeIcon
            class="text-avtalat-teal"
            :icon="expanded ? 'fa-regular fa-minus' : 'fa-regular fa-plus'"
          />
        </div>
      </div>
    </div>
    <div class="bg-white p-sm pt-xs" v-if="expanded">
      <div class="flex flex-col">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import { faMinus, faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ref } from "vue";

type FormGroupProps = {
  title: string;
  startExpanded?: boolean;
};
const props = defineProps<FormGroupProps>();

const expanded = ref(props.startExpanded);

library.add(faMinus, faPlus);
</script>
